module.exports = __webpack_public_path__ + "img/1.7fb4aa1c.jpg";